module.exports = __webpack_public_path__ + "static/media/header-title-2.8cf45920.jpg";